/**
 * @description
 * Controller for under maintenance
 */

angular.module('controllers')
    .controller('underMaintenance', ($window, $scope, $rootScope) => {

        $rootScope.State.loading = false;

    });



// WEBPACK FOOTER //
// ./scripts/controllers/underMaintenance.js